import React, { useState, useEffect, useRef } from "react";
import "./ReportTypeSelector.css";

const ReportTypeSelector = ({ selectedReportType, onReportTypeChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  const reportTypes = [
    { value: "original", label: "Original" },
    { value: "plainLanguage", label: "Plain language" },
  ];

  const handleReportTypeClick = (reportType) => {
    onReportTypeChange(reportType.value);
    setIsOpen(false);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);

  const currentReportType =
    reportTypes.find((type) => type.value === selectedReportType) ||
    reportTypes[0];

  return (
    <div className="report-type-selector" ref={wrapperRef}>
      <button
        className="report-type-select-button"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span>{currentReportType.label}</span>
        <svg
          className={`chevron-icon ${isOpen ? "open" : ""}`}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
            fill="currentColor"
          />
        </svg>
      </button>
      {isOpen && (
        <ul className="report-type-options">
          {reportTypes.map((type) => (
            <li
              key={type.value}
              className={`report-type-option ${
                type.value === selectedReportType ? "selected" : ""
              }`}
              onClick={() => handleReportTypeClick(type)}
            >
              <svg
                className="checkmark-icon"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
              </svg>
              {type.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ReportTypeSelector;
